import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  users: [],
  usersPagination: null,
});

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      localStorage.setItem('users', JSON.stringify(action.payload));
      state.users = action.payload;
    },
    setUsersPagination: (state, action) => {
      localStorage.setItem('usersPagination', JSON.stringify(action.payload));
      state.usersPagination = action.payload;
    },
  },
});

export const { setUsers, setUsersPagination } = usersSlice.actions;

export default usersSlice.reducer;
